import { useRef } from "react";
import TourUploadButton from "./PhotoUploadButton";
import { triggerAnalyticsEvent } from "../../lib";

interface PhotoSuccessProps {
  onConfirm: () => void;
  onRetake: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  paragraphText?: string;
}

/**
 * Component shown when a photo is successfully uploaded and ready for confirmation
 * - Allows the user to confirm the uploaded photo or select a different one
 * - Tracks analytics events for both confirmation and retakes
 */
export const PhotoSuccess = (props: PhotoSuccessProps) => {
  const { onConfirm, onRetake, children, paragraphText } = props;
  const confirmButtonRef = useRef<HTMLButtonElement>(null);
  const onConfirmClick = (onConfirm: () => void) => () => {
    reportAnalytics();
    onConfirm();
  };

  // Tracks the photo confirmation event for analytics
  // Captures the actual button text in case it changes in the future
  const reportAnalytics = () => {
    const eventButtonText = confirmButtonRef?.current?.innerText || "Yes";

    triggerAnalyticsEvent("sak_engagement_photo_upload_click", {
      event_action: "photo_confirm_click",
      event_category: "sak_photo_upload",
      event_label: eventButtonText
    });
  };

  return (
    <>
      <div className="sak-engagement-flow__header">
        <h2 className="sak-engagement-flow__header-text">Confirm your photo</h2>
      </div>
      <div className="sak-engagement-flow__body">
        <p>{paragraphText}</p>
      </div>
      {children}
      <div className="sak-engagement-flow__controls">
        <button
          className="btn btn-primary photo"
          onClick={onConfirmClick(onConfirm)}
          ref={confirmButtonRef}
        >
          Yes
        </button>
        <TourUploadButton
          classList="btn btn-ghost-orange"
          handleFileChange={onRetake}
          clickEventActionKey="photo_retake_click"
        >
          Reselect
        </TourUploadButton>
      </div>
    </>
  );
};

export default PhotoSuccess;
